import { useNavigate } from "react-router-dom";

export default function OpenSupportChatButton({
  participantId,
  chatTab = "users",
  participantName = "",
  participantAvatar = "",
  participantRole = "",
  label = "Message",
  className = "",
}) {
  const navigate = useNavigate();

  if (!participantId) return null;

  const handleClick = () => {
    navigate("/chat", {
      state: {
        participantId: String(participantId),
        chatTab,
        participantName,
        participantAvatar,
        participantRole:
          participantRole || (chatTab === "movers" ? "Driver" : "User"),
      },
    });
  };

  return (
    <button
      type="button"
      className={`open-support-chat-btn ${className}`.trim()}
      onClick={handleClick}
    >
      <i className="fas fa-comment-dots" aria-hidden="true" />
      {label}
    </button>
  );
}
